<template>
    <KRHPTyhiPaigutus portaaliPealkiri="Tere tulemast Kriminaalhooldusportaali!">
        <template #title>
            <h1 class="text-primary">Tere tulemast Kriminaalhooldusportaali!</h1>
        </template>
        <template #body>
            <v-row>
                <v-col>
                    <v-card class="pa-2">
                        <p class="mb-4">
                            Olete sisenenud Kriminaalhooldusportaali. Portaali eesmärgiks on koondada Teile vajalik info
                            virtuaalse toimikuna, et toetada Teie kriminaalhoolduse läbimist. Siin lehel hakkate edaspidi
                            nägema kogu Teie kriminaalhooldusega seonduvat informatsiooni ja dokumente.
                        </p>
                        <p class="mb-4">
                            Virtuaalse toimiku sisu avaneb Teile peale seda, kui olete kohtunud oma
                            kriminaalhooldusametnikuga ning andnud nõusoleku Kriminaalhooldusportaali kasutamiseks. Peale
                            seda saate infoga tutvuda Teile sobival ajal.
                        </p>
                        <p class="text-right"><v-btn  @click="logiValja"  size="large" color="light-blue-darken-3">Logi välja</v-btn></p>

                    </v-card>
                </v-col>
            </v-row>
        </template>
    </KRHPTyhiPaigutus>
</template>

<style scoped></style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPTyhiPaigutus from './uldine/KRHPTyhiPaigutus.vue';
import { AuthTeenus } from '@/core/auth-teenus';
import { mapActions } from 'pinia';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import { useAmetnikStore } from '@/stores/ametnikStore';
import { useTeavitusedStore } from '@/stores/teavitusedStore';
import { useTegevusedStore } from '@/stores/tegevusedStore';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';

const _authTeenus = new AuthTeenus();

export default defineComponent({
    name: 'JuurdepaasPoleLubatud',
    components: {
        KRHPTyhiPaigutus,
    },
    methods: {
        ...mapActions(useKasutajaStore, ['eemaldaKasutaja']),
        ...mapActions(useAmetnikStore, ['eemaldaAmetnik']),
        ...mapActions(useTeavitusedStore, ['eemaldaTeavitused']),
        ...mapActions(useTegevusedStore, ['eemaldaTegevused']),
        ...mapActions(useUldkasulikTooStore, ['eemaldaUldkasulikToo']),

        logiValja() {
            this.eemaldaKasutaja();
            this.eemaldaAmetnik();
            this.eemaldaTeavitused();
            this.eemaldaTegevused();
            this.eemaldaUldkasulikToo();
            _authTeenus.logiValja();
        }
    }
});
</script>